import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { getEstado } from "../../../utils/extractNumber";
import EstadoBadge from "./EstadoBadge";
import RolTable from "./RolTable";
import SuscriptTable from "./SuscriptTable";
import OrgTable from "./OrgTable";
import AccountActions from "./AccountActions";

const UserAccount = () => {
  const [value, setValue] = useState(0);
  const { suscriptions, myRoles, myOrgs } = useSingleUserControl();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: 1,
        border: "1px solid #336B8780",
        borderRadius: "7px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        px: 3,
        py: 2,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Typography variant="h3" sx={{ fontSize: "24px", fontWeight: "600" }}>
          Cuenta
        </Typography>
        <AccountActions />
      </Box>

      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={false}
        textColor="inherit"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#336B87",
            height: 2,
          },
        }}
        sx={{
          borderBottom: "1px solid #336B8780",
          ".MuiTabs-flexContainer": {
            justifyContent: "flex-start",
          },
          ".MuiTab-root": {
            color: "#5A5A5A",
            fontWeight: "bold",
            fontFamily: "Montserrat",
            fontSize: "16px",
            textTransform: "none",
            borderRight: "1px solid #336B8780",
            minWidth: "auto",
            px: 2,
            pt: "6px",
            pb: "4px",
            "&:last-of-type": {
              borderRight: "none",
            },
            "&:hover": {
              color: "#336B87",
            },
          },
          ".Mui-selected": {
            color: "#336B87",
          },
        }}
      >
        <Tab
          key="org"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              Organización
              <EstadoBadge estado={getEstado(myOrgs, "estado_org")} />
            </Box>
          }
        />
        <Tab
          key="suscr"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              Suscripciones
              <EstadoBadge estado={getEstado(suscriptions)} />
            </Box>
          }
        />
        <Tab
          key="rol"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              Roles
              <EstadoBadge estado={getEstado(myRoles)} />
            </Box>
          }
        />
      </Tabs>
      {value === 0 && <OrgTable />}
      {value === 1 && <SuscriptTable />}
      {value === 2 && <RolTable />}
    </Box>
  );
};

export default UserAccount;
